import { render, staticRenderFns } from "./PersonStatistics.vue?vue&type=template&id=d7ec88f4&scoped=true"
import script from "./PersonStatistics.vue?vue&type=script&lang=js"
export * from "./PersonStatistics.vue?vue&type=script&lang=js"
import style0 from "./PersonStatistics.vue?vue&type=style&index=0&id=d7ec88f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ec88f4",
  null
  
)

export default component.exports